const styles = ((theme) => ({
  blockA: {
    marginBottom: '50px'
  },
  inputMargin: {
    marginBottom: '10px'
  }
}))

export default styles;